export default "__VITE_ASSET__BJyEsJNt__"